import { Button, DialogActions } from "@mui/material";
import { useTranslation } from "react-i18next";
import './DialogActionsButtons.css';
import { MutableRefObject, useEffect, useRef } from "react";
import { useState } from "react";

type DialogActionsButtonsProps = {
    onClickCancel?: () => void;
    /**
     * Is not working correctly with submit
     * @returns 
     */
    onClick?: () => void;
    buttonText: string;
    floating?: boolean;
    parentRef?: MutableRefObject<HTMLElement | null>;
}

/**
 * The buttons are only rendered if the function for each is present.
 * @param param0 params
 * @returns DialogActionButtons
 */
export default function DialogActionsButtons({ onClick, onClickCancel, buttonText, floating = false, parentRef }: DialogActionsButtonsProps) {
    const { t } = useTranslation();
    const cancelButton = useRef<HTMLButtonElement>(null);
    const okButton = useRef<HTMLButtonElement>(null);
    const [onBottom, setOnBottom] = useState(false);


    const onClickOkButton = () => {
        if (!parentRef || onBottom) {
            setTimeout(() => { if (onClick) onClick(); });
        } else {
            scrollToBottom();
        }
    }

    useEffect(() => {
        const localRef = parentRef?.current;
        //console.log('localRef', localRef, localRef?.offsetHeight, localRef?.scrollTop, localRef?.scrollHeight);
        if (localRef && ((localRef.offsetHeight || 0) + ((localRef.scrollTop || 0) + 0.5) >= (localRef.scrollHeight || 0))) {
            setOnBottom(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const scrollToBottom = () => {
        parentRef?.current?.scrollTo(0, parentRef.current.scrollHeight);
        setOnBottom(true);
    }

    useEffect(() => {
        //console.log('parent', parentRef);
        function handleScroll() {
            if ((localRef?.offsetHeight || 0) + ((localRef?.scrollTop || 0) + 0.5) >= (localRef?.scrollHeight || 0)) {
                setOnBottom(true);
            } else {
                setOnBottom(false);
            }
        }
        const localRef = parentRef?.current;
        localRef?.addEventListener("scroll", handleScroll);

        return () => {
            localRef?.removeEventListener("scroll", handleScroll);
        };
    }, [parentRef]);

    if (floating) {
        return (
            <DialogActions sx={{ position: 'sticky', bottom: 0 }}>
                {onClickCancel && <Button ref={cancelButton} color="primary" className='parent' variant="contained" onClick={onClickCancel}><span className='dialogActionButton'>{t('cancel')}</span></Button>}
                <Button ref={okButton} color="primary" className='parent' variant="contained" type="submit" onClick={onClickOkButton}><span className='dialogActionButton'>{buttonText}</span></Button>
            </DialogActions>
        );
    }

    return (
        <DialogActions>
            {onClickCancel && <Button className='parent' variant="contained" onClick={onClickCancel}><span className='dialogActionButton'>{t('cancel')}</span></Button>}
            <Button className='parent' variant="contained" type="submit" onClick={() => setTimeout(() => { if (onClick) onClick(); })}><span className='dialogActionButton'>{buttonText}</span></Button>
        </DialogActions>
    );
}